import Reveal from "./Reveal";

const POINTS = [
    {
        num: "01",
        title: "High-intent traffic",
        copy: "Reach people actively looking for legal services.",
        testid: "positioning-high-intent-traffic",
    },
    {
        num: "02",
        title: "Conversion-focused execution",
        copy: "Connect advertising, landing pages, and tracking into one system.",
        testid: "positioning-conversion-focused-execution",
    },
    {
        num: "03",
        title: "Performance-driven decisions",
        copy: "Use real conversion data to determine what deserves more investment.",
        testid: "positioning-performance-driven-decisions",
    },
];

export const Positioning = () => (
    <section id="positioning" className="py-24 md:py-32 lg:py-40">
        <div className="shell grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
            <div>
                <Reveal>
                    <p className="eyebrow mb-5">Positioning</p>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2 className="font-serif font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.15] text-white">
                        Clicks are easy. Qualified consultations are the goal.
                    </h2>
                </Reveal>
                <Reveal delay={0.16}>
                    <p className="mt-7 text-base lg:text-lg leading-relaxed text-zinc-400">
                        Scalehaus is built around performance, not vanity
                        metrics.
                    </p>
                </Reveal>
                <Reveal delay={0.22}>
                    <p className="mt-5 text-base lg:text-lg leading-relaxed text-zinc-400">
                        We don't optimize campaigns simply to generate more
                        clicks or impressions. We focus on the metrics that
                        matter to a law firm: qualified inquiries, consultation
                        bookings, and measurable acquisition.
                    </p>
                </Reveal>
            </div>
            <div>
                {POINTS.map((p, i) => (
                    <Reveal key={p.num} delay={0.08 + i * 0.1}>
                        <div
                            data-testid={p.testid}
                            className={`flex gap-7 py-8 border-t border-white/10 ${
                                i === POINTS.length - 1 ? "border-b" : ""
                            }`}
                        >
                            <span className="font-serif italic text-3xl text-brass-500/50 leading-none pt-1">
                                {p.num}
                            </span>
                            <div>
                                <h3 className="font-serif text-xl md:text-2xl text-white">
                                    {p.title}
                                </h3>
                                <p className="mt-2 text-sm md:text-base leading-relaxed text-zinc-400">
                                    {p.copy}
                                </p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Positioning;
